export default "__VITE_ASSET__BjowrY_s__"